// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsgUuYqrkocwDGFzFNufEbmlFWkWg2xtY",
  authDomain: "ella-ryan.firebaseapp.com",
  projectId: "ella-ryan",
  storageBucket: "ella-ryan.firebasestorage.app",
  messagingSenderId: "536990668368",
  appId: "1:536990668368:web:c21cbe9bc7a255e16ba355",
  measurementId: "G-XZV2M269ED"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);